module.exports = __webpack_public_path__ + "static/media/AP1_4613-2.de404a52.jpg";